import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ScheduleIcon from "@mui/icons-material/Schedule";
import TuneIcon from "@mui/icons-material/Tune";
import CategoryIcon from "@mui/icons-material/Category";
import CircularProgress from "@mui/material/CircularProgress";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import ExamExternalSchedule from "./ExamExternalSchedule";
import InternalExamSchedule from "./InternalExamSchedule";
import ExamTimeTable from "./ExamTimeTable";
import ExamCourseAllotment from "./ExamCourseAllotment";
import ExamPaperTemplate from "./ExamPaperTemplate";
import StaffExternal from "./StaffExternal";
import CourseMasterReport from "./CourseMasterReport";
import CourseRegulationReport from "./CourseRegulationReport";
import RoomCapacitySummary from "./RoomCapacitySummary";
import ScriptValuation from "./ScriptValuation";
import BacklogsReport from "./BacklogsReport";
import StudentResultHistoryCheck from "./StudentResultHistoryCheck";
import StudentBacklogCheck from "./StudentBacklogCheck";
import SupplyExamFee from "./SupplyExamFee";
import ValuationRates from "./ValuationRates";
import RegularExamFee from "./RegularExamFee";
import ExamDashboard from "./ExamDashboard";
import ScholarshipResultReport from "./ScholarshipResultReport";
import UploadCourse from "../../client/Upload/UploadCourse";
import UploadRoom from "../../client/Upload/UploadRoom";
import ExamType from "../../client/LookUp/ExamType";
import ExamMode from "../../client/LookUp/ExamMode";
import ExamSlot from "../../client/LookUp/ExamSlot";
import ScriptPendingStaff from "./ScriptPendingStaff";

function Exams() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [loading, setLoading] = useState(true);
  const [activeView, setActiveView] = useState("home");
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(2);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  const getAuthHeaders = () => {
    const token = sessionStorage.getItem("token");
    return {
      Authorization: `Bearer ${token}`,
    };
  };

  const handleNavigate = (path) => {
    const token = sessionStorage.getItem("token");
    if (!token) {
      navigate("/authentication/sign-in");
    } else {
      setActiveView(path);
    }
  };

  const handleBack = () => {
    if (activeView !== "home") setActiveView("tabs");

    if (activeView === "tabs") {
      setActiveView("home");
      navigate("/admin/exams");
    }
  };

  const handleToggleView = () => {
    setActiveView((prev) => (prev === "home" ? "tabs" : "home"));
  };
  const MenuCard = ({ title, icon, path, color = "#2196F3" }) => (
    <Grid item xs={12} sm={6} md={4} lg={2.4}>
      <MDButton
        fullWidth
        variant="gradient"
        size="large"
        startIcon={icon}
        sx={{
          height: 90,
          fontSize: "0.85rem",
          fontWeight: 700,
          letterSpacing: "0.2px",
          borderRadius: "12px",
          color: "#FFFFFF !important",
          background: `linear-gradient(135deg, ${color} 0%, ${color}CC 100%)`,
          boxShadow: `0 4px 12px ${color}40`,
          transition: "all 0.25s ease",
          "&:hover": {
            background: `linear-gradient(135deg, ${color} 0%, ${color}DD 100%)`,
            transform: "translateY(-4px)",
            boxShadow: `0 8px 20px ${color}60`,
          },
          "& .material-icons-round, & .material-icons": {
            fontSize: "28px",
            color: "#FFFFFF !important",
          },
          "& .MuiSvgIcon-root": {
            fontSize: "28px",
            color: "#FFFFFF",
          },
        }}
        onClick={() => handleNavigate(path)}
      >
        {title}
      </MDButton>
    </Grid>
  );

  MenuCard.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    path: PropTypes.string.isRequired,
    color: PropTypes.string,
  };

  const renderContent = () => {
    switch (activeView) {
      case "examcourse":
        return (
          <>
            <ExamCourseAllotment />
          </>
        );
      case "examschedule":
        return (
          <>
            <ExamExternalSchedule />
          </>
        );
      case "internalexamschedule":
        return (
          <>
            <InternalExamSchedule />
          </>
        );
      case "examtimetable":
        return (
          <>
            <ExamTimeTable />
          </>
        );
      case "exampapertemplate":
        return (
          <>
            <ExamPaperTemplate />
          </>
        );
      case "staffexternal":
        return (
          <>
            <StaffExternal />
          </>
        );

      case "coursemasterreport":
        return (
          <>
            <CourseMasterReport />
          </>
        );
      case "courseregulationreport":
        return (
          <>
            <CourseRegulationReport />
          </>
        );
      case "roomcapacity":
        return (
          <>
            <RoomCapacitySummary />
          </>
        );
      case "scriptvaluation":
        return (
          <>
            <ScriptValuation />
          </>
        );
      case "backlogsreport":
        return (
          <>
            <BacklogsReport />
          </>
        );
      case "studentresulthistorycheck":
        return (
          <>
            <StudentResultHistoryCheck />
          </>
        );
      case "studentbacklog":
        return (
          <>
            <StudentBacklogCheck />
          </>
        );
      case "supplyexamfee":
        return (
          <>
            <SupplyExamFee />
          </>
        );
      case "scholarshipresultreport":
        return (
          <>
            <ScholarshipResultReport />
          </>
        );
      case "uploadcourse":
        return (
          <>
            <UploadCourse />
          </>
        );
      case "uploadroom":
        return (
          <>
            <UploadRoom />
          </>
        );
      case "examtype":
        return (
          <>
            <ExamType />
          </>
        );
      case "exammode":
        return (
          <>
            <ExamMode />
          </>
        );
      case "examslot":
        return (
          <>
            <ExamSlot />
          </>
        );
      case "valuationrates":
        return <ValuationRates />;
      case "regularexamfee":
        return <RegularExamFee />;
      case "scriptpendingstaff":
        return <ScriptPendingStaff />;
      default:
        return (
          <>
            {activeView === "home" ? (
              /* DEFAULT DASHBOARD */
              <ExamDashboard onNavigate={handleNavigate} onToggleView={handleToggleView} />
            ) : (
              /* EXISTING TABS AND MENU CARDS */
              <>
                <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    TabIndicatorProps={{
                      sx: {
                        backgroundColor: ["#2196F3", "#4CAF50", "#FF9800", "#9C27B0"][tabValue],
                        height: 5,
                        borderRadius: "4px 4px 0 0",
                      },
                    }}
                  >
                    {[
                      {
                        label: "UPLOAD",
                        icon: <CloudUploadIcon />,
                        color: "#2196F3",
                        bgColor: "rgba(33, 150, 243, 0.10)",
                      },
                      {
                        label: "SETUP",
                        icon: <SettingsSuggestIcon />,
                        color: "#4CAF50",
                        bgColor: "rgba(76, 175, 80, 0.10)",
                      },
                      {
                        label: "ACTIONS",
                        icon: <TouchAppIcon />,
                        color: "#FF9800",
                        bgColor: "rgba(255, 152, 0, 0.12)",
                      },
                      {
                        label: "REPORTS",
                        icon: <AssessmentIcon />,
                        color: "#9C27B0",
                        bgColor: "rgba(156, 39, 176, 0.10)",
                      },
                    ].map((item, index) => (
                      <Tab
                        key={item.label}
                        icon={item.icon}
                        iconPosition="top"
                        label={
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: 0.2,
                            }}
                          >
                            <Box
                              component="span"
                              sx={{
                                fontSize: "1rem",
                                fontWeight: 600,
                                letterSpacing: "0.1px",
                                lineHeight: 1.5,
                              }}
                            >
                              {item.label}
                            </Box>

                            {tabValue === index && (
                              <KeyboardArrowDownIcon
                                sx={{
                                  fontSize: 30,
                                  color: item.color,
                                  strokeWidth: 2,
                                  filter: "drop-shadow(0 1px 1px rgba(0,0,0,0.25))",
                                  mt: 0.2,
                                }}
                              />
                            )}
                          </Box>
                        }
                        sx={{
                          minHeight: 105,
                          py: 1.2,
                          fontWeight: 800,
                          color: `${item.color} !important`,
                          opacity: 1,
                          borderRadius: "10px 10px 0 0",
                          transition: "all 0.25s ease",

                          "& .MuiSvgIcon-root": {
                            fontSize: 34,
                            color: item.color,
                            transition: "transform 0.25s ease",
                          },

                          "&:hover": {
                            backgroundColor: item.bgColor,
                            "& > .MuiTab-iconWrapper": {
                              transform: "scale(1.12)",
                            },
                          },

                          ...(tabValue === index && {
                            backgroundColor: item.bgColor,
                            "& .MuiSvgIcon-root": {
                              color: item.color,
                            },
                          }),
                        }}
                      />
                    ))}
                  </Tabs>
                </Box>

                {/* UPLOADS */}
                {tabValue === 0 && (
                  <Grid container spacing={2}>
                    <MenuCard
                      title="UPLOAD COURSES"
                      icon={<CategoryIcon />}
                      path="uploadcourse"
                      color="#2196F3"
                    />
                    <MenuCard
                      title="UPLOAD ROOMS"
                      icon={<CategoryIcon />}
                      path="uploadroom"
                      color="#03A9F4"
                    />
                    <MenuCard
                      title="EXTERNAL STAFF"
                      icon={<CategoryIcon />}
                      path="staffexternal"
                      color="#00BCD4"
                    />
                  </Grid>
                )}

                {/* SETUP */}
                {tabValue === 1 && (
                  <Grid container spacing={2}>
                    <MenuCard
                      title="MANAGE EXAM TYPES"
                      icon={<CategoryIcon />}
                      path="examtype"
                      color="#4CAF50"
                    />
                    <MenuCard
                      title="MANAGE EXAM MODES"
                      icon={<TuneIcon />}
                      path="exammode"
                      color="#009688"
                    />
                    <MenuCard
                      title="MANAGE EXAM SLOTS"
                      icon={<ScheduleIcon />}
                      path="examslot"
                      color="#8BC34A"
                    />
                    <MenuCard
                      title="EXAM PAPER TEMPLATE"
                      icon={<CategoryIcon />}
                      path="exampapertemplate"
                      color="#2E7D32"
                    />
                    <MenuCard
                      title="COURSE/SUBJECT ALLOTMENT"
                      icon={<CategoryIcon />}
                      path="examcourse"
                      color="#26A69A"
                    />
                    <MenuCard
                      title="EXAM VALUATION RATES"
                      icon={<Icon>currency_rupee</Icon>}
                      path="valuationrates"
                      color="#66BB6A"
                    />
                    <MenuCard
                      title="REGULAR EXAM FEE"
                      icon={<Icon>payments</Icon>}
                      path="regularexamfee"
                      color="#00A86B"
                    />
                    <MenuCard
                      title="SUPPLY EXAM FEE"
                      icon={<CategoryIcon />}
                      path="supplyexamfee"
                      color="#558B2F"
                    />
                  </Grid>
                )}

                {/* ACTIONS */}
                {tabValue === 2 && (
                  <Grid container spacing={2}>
                    <MenuCard
                      title="MID EXAM SCHEDULE"
                      icon={<ScheduleIcon />}
                      path="internalexamschedule"
                      color="#FF9800"
                    />
                    <MenuCard
                      title="EXTERNAL SCHEDULE"
                      icon={<ScheduleIcon />}
                      path="examschedule"
                      color="#F4511E"
                    />
                    <MenuCard
                      title="EXTERNAL TIMETABLES"
                      icon={<ScheduleIcon />}
                      path="examtimetable"
                      color="#FB8C00"
                    />
                    <MenuCard
                      title="SCRIPTS VALUATION"
                      icon={<Icon>assignment</Icon>}
                      path="scriptvaluation"
                      color="#E65100"
                    />
                  </Grid>
                )}

                {/* REPORTS */}
                {tabValue === 3 && (
                  <Grid container spacing={2}>
                    <MenuCard
                      title="COURSE MASTER"
                      icon={<Icon>description</Icon>}
                      path="coursemasterreport"
                      color="#9C27B0"
                    />
                    <MenuCard
                      title="COURSE REGULATION"
                      icon={<Icon>description</Icon>}
                      path="courseregulationreport"
                      color="#673AB7"
                    />
                    <MenuCard
                      title="ROOM CAPACITY"
                      icon={<Icon>meeting_room</Icon>}
                      path="roomcapacity"
                      color="#5C6BC0"
                    />
                    <MenuCard
                      title="CHECK BACKLOGS"
                      icon={<Icon>assignment</Icon>}
                      path="studentbacklog"
                      color="#7E57C2"
                    />
                    <MenuCard
                      title="STUDENT RESULT"
                      icon={<Icon>assignment</Icon>}
                      path="studentresulthistorycheck"
                      color="#AB47BC"
                    />
                    <MenuCard
                      title="BACKLOGS REPORT"
                      icon={<Icon>assignment</Icon>}
                      path="backlogsreport"
                      color="#8E24AA"
                    />
                    <MenuCard
                      title="SCHOLARSHIP RESULT"
                      icon={<Icon>workspace_premium</Icon>}
                      path="scholarshipresultreport"
                      color="#6A1B9A"
                    />
                    <MenuCard
                      title="PENDING SCRIPTS"
                      icon={<Icon>workspace_premium</Icon>}
                      path="scriptpendingstaff"
                      color="#AD1457"
                    />
                  </Grid>
                )}
              </>
            )}
          </>
        );
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={2} pb={3}>
        {loading ? (
          <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
            <CircularProgress color="info" />
          </MDBox>
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                {/* HEADER - Matching Library Management System card design */}
                <MDBox
                  mx={2}
                  mt={-1}
                  py={1}
                  px={2}
                  bgColor="info"
                  borderRadius="lg"
                  coloredShadow="info"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  flexWrap="wrap"
                  gap={1}
                >
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon sx={{ color: "#FFFFFF" }}>assignment</Icon>

                    <MDTypography variant="h6" color="white">
                      MANAGE EXAMS
                    </MDTypography>
                  </MDBox>

                  {activeView !== "home" ? (
                    <MDButton
                      variant="contained"
                      onClick={handleBack}
                      startIcon={<Icon>arrow_back</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF !important",
                        backgroundColor: "rgba(255,255,255,0.18) !important",
                        boxShadow: "none !important",
                        "& .material-icons": {
                          color: "#FFFFFF !important",
                        },
                        "&:hover": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                          boxShadow: "none !important",
                        },
                        "&:focus": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.18) !important",
                        },
                        "&:active": {
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                        },
                      }}
                    >
                      Back to Exams
                    </MDButton>
                  ) : (
                    <MDButton
                      variant="contained"
                      onClick={() => navigate("/dashboard")}
                      startIcon={<Icon>dashboard</Icon>}
                      sx={{
                        mb: 0,
                        color: "#FFFFFF !important",
                        backgroundColor: "rgba(255,255,255,0.18) !important",
                        boxShadow: "none !important",
                        "& .material-icons": {
                          color: "#FFFFFF !important",
                        },
                        "&:hover": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                          boxShadow: "none !important",
                        },
                        "&:focus": {
                          color: "#FFFFFF !important",
                          backgroundColor: "rgba(255,255,255,0.18) !important",
                        },
                        "&:active": {
                          backgroundColor: "rgba(255,255,255,0.28) !important",
                        },
                      }}
                    >
                      Dashboard
                    </MDButton>
                  )}
                </MDBox>

                {/* CONTENT */}
                <MDBox p={1}>{renderContent()}</MDBox>
              </Card>
            </Grid>
          </Grid>
        )}
      </MDBox>
      <MDBox display="flex" flexDirection="column" minHeight="50vh"></MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Exams;
